import { assetLoader, audioPlayer } from "../PhaserExtension";
import * as States from "./States";
import * as GameModel from "../models/GameModel";
import StoryCircleState from "./StoryCircleState";
import StoryCircleState2P from "./StoryCircleState2P";
import BaseState from "./BaseState";
import FlumpButton from "../general/objects/FlumpButton";
import TitleButton from "../title/objects/TitleButton";

export default class TitleState extends BaseState
{
    preload()
    {
        assetLoader.preloadAssetPacks(this.game, ["title"]);
        super.preload();
    }

    create()
    {
        this.game.world.setBounds(-this.game.width / 2, 0, this.game.width * 4, this.game.height);
        this.game.state.remove(States.STORYCIRCLE);
        this.config = this.game.cache.getJSON("titleConfig");
        audioPlayer.setupChannels(this.config.sounds.channels);
        this.playedTitle = false;

        if(this.game.sound.context && this.game.sound.context.state && this.game.sound.context.state === "suspended")
        {
            this.game.input.onDown.addOnce(function()
            {
                this.game.sound.context.resume();
                audioPlayer.stopAllChannels();
                audioPlayer.play(this.game, this.config.variables.music);
                audioPlayer.play(this.game, this.config.variables.title, this.onTitleVOComplete, this);
                this.playedTitle = true;
            }.bind(this));
        }
        else
        {
            audioPlayer.play(this.game, this.config.variables.music);
        }

        this.background = new Phaser.TileSprite(this.game, this.game.width / -2, 0, this.game.width * 4, this.game.height, this.config.assets.background.display.key);
        this.backgroundLayer.add(this.background);

        this.logo = new Phaser.Sprite(this.game, this.config.assets.title.transform.position.x, this.config.assets.title.transform.position.y, this.config.assets.title.key);
        this.backgroundLayer.add(this.logo);

        // Main screen
        this.playButton = new FlumpButton(this.game, this.config.assets.playButton, "mainFlump");
        this.playButton.onClicked.add(this.playClicked, this);
        this.maingroundLayer.add(this.playButton);

        // Language screen
        let base = this.game.width;
        let conf = this.config.assets.languageScreen;
        this.englishButton = new TitleButton(this.game, conf.englishButton, "mainFlump");
        this.maingroundLayer.add(this.englishButton);
        this.englishButton.x += base;
        this.englishButton.onClicked.add(this.languageButtonClicked, this, 0, true);

        this.spanishButton = new TitleButton(this.game, conf.spanishButton, "mainFlump");
        this.maingroundLayer.add(this.spanishButton);
        this.spanishButton.x += base;
        this.spanishButton.onClicked.add(this.languageButtonClicked, this, 0, false);

        // Players screen
        base = this.game.width * 2;
        conf = this.config.assets.playersScreen;
        this.onePlayerButton = new TitleButton(this.game, conf.onePlayerButton, "mainFlump");
        this.maingroundLayer.add(this.onePlayerButton);
        this.onePlayerButton.onClicked.add(this.startGame, this, 0, false);
        this.onePlayerButton.x += base;

        this.twoPlayerButton = new TitleButton(this.game, conf.twoPlayerButton, "mainFlump");
        this.maingroundLayer.add(this.twoPlayerButton);
        this.twoPlayerButton.onClicked.add(this.startGame, this, 0, true);
        this.twoPlayerButton.x += base;

        GameModel.data.storyKey = "";
        GameModel.data.drawHistory = [];
        GameModel.data.turn = "";
        GameModel.data.lastPlayer = 1;
        GameModel.data.lastMuppet = -1;
        this.hasInteracted = false;

        this.timeoutTimer = this.game.time.create(false);
        this.timeoutTimer.loop(this.config.variables.timeoutLength, this.onTimeout, this);
        this.englishTimeout = true;
        this.timeoutCount = 0;
        this.timeoutFiredTime = 0;

        super.create();

        GameModel.sendEvent("Load", "Complete", Date.now() - GameModel.data.gameBootTime);
    }

    onTransitionInComplete()
    {
        super.onTransitionInComplete();
        if(!this.playedTitle && this.game.sound.context && this.game.sound.context.state && this.game.sound.context.state === "running")
        {
            audioPlayer.play(this.game, this.config.variables.title, this.onTitleVOComplete, this);
        }
    }

    onTitleVOComplete()
    {
        if(!this.hasInteracted)
        {
            audioPlayer.play(this.game, this.config.variables.start);
        }
        this.timeoutTimer.start();
    }

    onTimeout()
    {
        if(this.timeoutCount == 0)
        {
            this.timeoutFiredTime = Date.now();
        }
        this.timeoutCount++;

        if(this.englishButton.inCamera)
        {
            if(this.englishTimeout)
            {
                audioPlayer.play(this.game, this.config.variables.languageTimeout.toEnglish);
            }
            else
            {
                audioPlayer.play(this.game, this.config.variables.languageTimeout.toSpanish);
            }

            this.englishTimeout = !this.englishTimeout;
            GameModel.sendEvent("TimeoutPlay", "Language Selection screen_Number_" + GameModel.fixNumber(this.timeoutCount));
        }
        else if(this.onePlayerButton.inCamera)
        {
            audioPlayer.play(this.game, this.config.variables.players[+GameModel.data.english]);
            GameModel.sendEvent("TimeoutPlay", "Number of Players screen_Number_" + GameModel.fixNumber(this.timeoutCount));
        }
        else
        {
            audioPlayer.play(this.game, this.config.variables.startTimeout);
            GameModel.sendEvent("TimeoutPlay", "Title Screen_Number_" + GameModel.fixNumber(this.timeoutCount));
        }
    }

    playClicked()
    {
        if(this.timeoutCount > 0)
        {
            GameModel.sendEvent("TOReEnage", "Title Screen", Date.now() - this.timeoutFiredTime);
        }

        GameModel.sendEvent("Start", "StartButton");
        GameModel.data.currentStateName = "Language Selection screen";
        this.panTo(this.game.width);
    }

    panTo(targetX)
    {
        this.hasInteracted = true;
        this.game.add.tween(this.game.camera).to({x:targetX}, 900, Phaser.Easing.Back.Out, true).onComplete.addOnce(this.panComplete, this);
        this.game.input.enabled = false;
        audioPlayer.stopChannel("VO", true);
        this.timeoutCount = 0;
        this.restartTimeout();
    }

    panComplete()
    {
        this.game.input.enabled = true;
    }

    languageButtonClicked(english)
    {
        if(this.timeoutCount > 0)
        {
            GameModel.sendEvent("TOReEnage", "Language Selection screen", Date.now() - this.timeoutFiredTime);
        }

        GameModel.data.english = english;
        GameModel.sendEvent("LanguageSelect", english ? "English" : "Spanish");
        GameModel.data.currentStateName = "Number of Players screen";

        this.panTo(this.game.width * 2);
    }

    startGame(twoPlayer)
    {
        if(this.timeoutCount > 0)
        {
            GameModel.sendEvent("TOReEnage", "Number of Players screen", Date.now() - this.timeoutFiredTime);
        }

        GameModel.data.isTwoPlayer = twoPlayer;
        GameModel.sendEvent("PlayerSelect", twoPlayer ? "Two" : "One");

        if(GameModel.data.isTwoPlayer)
        {
            this.game.state.add(States.STORYCIRCLE, StoryCircleState2P);
            this.transistionOut();
        }
        else
        {
            this.game.state.add(States.STORYCIRCLE, StoryCircleState);
            this.transistionOut();
        }
    }

    onTransitionOutComplete()
    {
        var platform = this.game.device.desktop ? "desktop" : "mobile";
        var language = GameModel.data.english ? "en" : "es";
        this.game.cache.removeSound("prompt");
        this.game.cache.removeSound("promptHere");
        this.game.load.audio("prompt", this.sharedConfig.variables.promptPath[platform][language]);
        this.game.load.audio("promptHere", this.sharedConfig.variables.promptHerePath[platform][language]);
        this.game.load.start();

        this.game.state.start(States.STORYCIRCLE);
        //this.game.state.start(States.POSTGAME);
    }

    restartTimeout()
    {
        this.timeoutTimer.stop(false);
        this.timeoutTimer.start();
    }

    shutdown()
    {
        audioPlayer.cleanupChannels(this.config.sounds.channels);
        assetLoader.unloadAssetPacks(this.game, ["title"]);
        this.timeoutTimer.stop();
        this.timeoutTimer.destroy();
        super.shutdown();
    }
}
